import { Grid, Stack } from '@mui/material';
import styled from 'styled-components';
import { theme } from '../theme';

interface FilterWrapperProps {
  grayBackground?: boolean;
}

export const FilterWrapper = styled.div<FilterWrapperProps>`
padding: 10px;
  position: relative;
  /* border: 2px solid ${() => theme.palette.primary.light}; */
  border-radius: 10px;
  margin-bottom: 10px;
  margin-top: 10px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.08);
  background-color: ${({ grayBackground }) =>
    grayBackground ? theme.palette.custom.primaryXXLight : 'transparent'};
`;

export const GraphicFilterHeaderContainer = styled(Stack)`
  overflow: auto;
  white-space: nowrap; /* Evita il wrapping degli elementi */
  &::-webkit-scrollbar {
    display: none; /* Nasconde la scrollbar su Chrome, Safari */
  }
  scrollbar-width: none; /* Nasconde la scrollbar su Firefox */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px; /* Equivalente a spacing={1} */
  min-height: 58px;
`;

export const ScrollableStack = styled(Stack)`
  flex: 1; /* Per occupare lo spazio disponibile */
  overflow-x: auto; /* Abilita lo scroll orizzontale */
  overflow-y: hidden; /* Evita lo scroll verticale */
  white-space: nowrap; /* Per mantenere gli elementi in una riga */
  scrollbar-width: none; /* Nascondi scrollbar (per Firefox) */
  -ms-overflow-style: none; /* Nascondi scrollbar (per IE e Edge) */
  &::-webkit-scrollbar {
    display: none; /* Nascondi scrollbar (per Webkit-based browsers) */
  }
`;

export const GridDashboardWrapper = styled(Grid)`
  /* height: calc(100vh - 190px); */
  margin-top: 0px;
`;

export const WidgetWrapper = styled(Stack)`
  /* border: ${() => '2.1px solid ' + theme.palette.primary.light}; */
  border-radius: 8px;
  background-color: ${() => theme.palette.common.white};
  height: 100%;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.08);
  max-height: calc(100vh - 340px);
  overflow-y: auto;
`;

export const WidgetHeader = styled.div`
  padding-top: 14px !important;
  padding-bottom: 14px !important;
  height: 25px;
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  align-items: center;
  /* border-radius: 5px 5px 0 0; */
  /* border-bottom: ${() => '2px solid ' + theme.palette.primary.light}; */
  background-color: ${() => 'rgb(214 212 203)'};
`;

export const WidgetNumberBody = styled.div`
  height: calc(100% - 25px);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px;
`;

export const WidgetBarBody = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100% - 25px);
  padding: 10px 20px;
`;

export const WidgetPieBody = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: inherit;
  height: calc(100% - 25px);
`;

export const WidgetPerCustomerBody = styled.div`
  padding: 10px;
  height: 250px;
  overflow-y: auto;
  height: calc(100% - 25px);
  ::-webkit-scrollbar-track {
    background-color: ${() => theme.palette.common.white};
    border-radius: 5px;
  }
  ::-webkit-scrollbar {
    width: 7px;
    border-radius: 5px;
    background-color: ${() => theme.palette.common.white};
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: ${() => theme.palette.primary.main};
  }
`;

export const ListContainer = styled.div`
  background-color: ${() => theme.palette.common.white};
`;
